/**
 * Returns a boolean of whether the whole form is completed (percentage >= 100)
 *
 * Technically something must've gone wrong if the percentage is over 100 but it
 * at least removes the chance of false negatives
 */

import { createSelector } from 'reselect';

import questionsCompletedPercentageSelector from '/business/shared/state/selectors/application/step1/questionsCompletedPercentageSelector';
import type { Step1SelectorProps } from '/business/shared/state/selectors/types';
import type { RootState } from '/business/shared/state/store';

type IsFormCompletedSelector = (state: RootState, props: Step1SelectorProps) => boolean;

const isFormCompletedSelector = createSelector(
  questionsCompletedPercentageSelector,
  (percentageCompleted) => percentageCompleted >= 100,
) as IsFormCompletedSelector;

export default isFormCompletedSelector;
